import React from 'react';
import { LockIcon, ZapIcon, CheckCircleIcon, ShieldCheckIcon } from 'lucide-react';
import { TrustBadges } from './TrustBadges';
export function HeroSection() {
  const scrollToPricing = () => {
    const pricingCta = document.getElementById('pricing-cta');
    if (pricingCta) {
      pricingCta.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
      setTimeout(() => {
        pricingCta.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }, 100);
    }
  };
  return <section className="w-full bg-[#1a2332] py-16 px-4 md:py-24" data-id="element-107">
      <div className="max-w-6xl mx-auto" data-id="element-108">
        {/* Trust Badges Top */}
        <div className="mb-10" data-id="element-109">
          <TrustBadges data-id="element-110" />
        </div>

        {/* Two-column layout */}
        <div className="grid md:grid-cols-2 gap-10 md:gap-16 items-center mb-12" data-id="element-111">
          {/* Left Column — Text */}
          <div data-id="element-112">
            <span className="inline-block px-4 py-2 bg-[#fbbf24] text-[#1a2332] text-sm font-semibold rounded-full mb-6" data-id="element-113">
              EDICIÓN CHILE 2026
            </span>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight" data-id="element-114">
              SOLO-SURVIVAL:{' '}
              <span className="text-[#fbbf24]" data-id="element-115">EL PROTOCOLO DESPENSA 1.0</span>
            </h1>

            <p className="text-lg md:text-xl text-gray-300 leading-relaxed mb-8" data-id="element-116">
              Deja de pagar el "impuesto a gastar de más": El sistema de
              ingeniería de compras para ahorrar un 40% mensual en el
              supermercado si vives solo.
            </p>
          </div>

          {/* Right Column — Mockup Image */}
          <div className="flex justify-center" data-id="element-117">
            <img src="https://cdn.magicpatterns.com/uploads/uqC96pfgaCxcbdBC92Wcvw/heylloyd-image-1774535305237.png" alt="Solo-Survival Protocolo Despensa 1.0 - Laptop y móvil mostrando el sistema" className="max-w-full h-auto rounded-lg shadow-2xl" data-id="element-118" />
          </div>
        </div>

        {/* CTA Button — Below main image */}
        <div className="max-w-2xl mx-auto text-center mb-10" data-id="element-119">
          <button onClick={scrollToPricing} className="w-full py-5 px-10 bg-[#C5A059] text-white text-lg md:text-xl font-bold rounded-full hover:bg-[#b8923e] transform hover:scale-[1.02] transition-all duration-200 shadow-lg tracking-wide" data-id="element-120">
            ¡QUIERO EMPEZAR A AHORRAR!
          </button>

          {/* Price Block — Below CTA */}
          <div className="mt-4" data-id="element-121">
            <p className="text-base text-gray-300" data-id="element-122">
              Acceso instantáneo •{' '}
              <span className="line-through text-gray-500" data-id="element-123">$19.990</span>{' '}
              <span className="font-bold text-[#22c55e] text-xl" data-id="element-124">
                $9.500 CLP
              </span>{' '}
              <span className="inline-block bg-[#22c55e] text-white text-xs font-bold px-2 py-0.5 rounded-full" data-id="element-125">
                -52%
              </span>{' '}
              • Pago único de por vida
            </p>
          </div>

          {/* Multi-device access — Below discount */}
          <p className="text-sm text-gray-400 mt-3" data-id="element-126">
            📱 Accede desde tu celular, tablet o computador — al instante
            después de tu compra
          </p>
        </div>

        {/* Guarantee Box — Full width below columns */}
        <div className="max-w-2xl mx-auto" data-id="element-127">
          <div className="bg-[#1B3022] rounded-2xl px-6 py-6" data-id="element-128">
            <div className="flex items-start gap-4" data-id="element-129">
              <div className="flex-shrink-0 mt-0.5" data-id="element-130">
                <ShieldCheckIcon className="w-8 h-8 text-[#22c55e]" data-id="element-131" />
              </div>
              <div data-id="element-132">
                <h4 className="text-white font-bold text-lg mb-2" data-id="element-133">
                  Garantía de Recuperación de Inversión
                </h4>
                <p className="text-white/80 leading-relaxed text-sm md:text-base" data-id="element-134">
                  Si en tu primera compra de supermercado aplicando el protocolo
                  no ahorras al menos el triple de lo que costó esta guía, te
                  devolvemos el 100% de tu dinero. Sin preguntas.
                </p>
              </div>
            </div>
            {/* Payment Icons */}
            <div className="flex items-center justify-center gap-6 mt-5 pt-5 border-t border-white/10" data-id="element-135">
              <span className="text-xs font-bold tracking-wider text-white/40 border border-white/20 rounded px-3 py-1.5" data-id="element-136">
                WebPay
              </span>
              <span className="text-xs font-bold tracking-wider text-white/40 border border-white/20 rounded px-3 py-1.5" data-id="element-137">
                VISA
              </span>
              <span className="text-xs font-bold tracking-wider text-white/40 border border-white/20 rounded px-3 py-1.5" data-id="element-138">
                Mastercard
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}